import { render } from "./ServicePrices.vue?vue&type=template&id=4c0c84d8"
import script from "./ServicePrices.vue?vue&type=script&lang=js"
export * from "./ServicePrices.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__